if (!customElements.get("combined-products")) {
	customElements.define(
		"combined-products",
		class CombinedProducts extends HTMLElement {
			constructor() {
				super()
				this.variant_data = JSON.parse(this.querySelector("#combined-products-data").innerHTML)

				this.input = this.querySelector("input")

				this.interval = false

				if (!this.input || !this.variant_data) return

				this.original_value = this.input.value

				this.input.addEventListener("input", (e) => this.handleInput(e))
			}

			handleInput(e) {
				var choke = 500

				if (this.interval) {
					//reset interval waiting for choke ms before proceeding
					clearTimeout(this.interval)
				}

				if (this.input.value == "") {
					return
				}

				this.interval = setTimeout(() => {
					var value = parseInt(this.input.value) //dollars

					var rounded_value = Math.round(value / 5) * 5

					if (isNaN(value) || isNaN(rounded_value)) return

					if (value != rounded_value) {
						this.input.value = rounded_value
						//show warning
						this.classList.add("show-warning")
					}

					//find matching variant from data
					var matched_variant = this.matchingVariantValue(rounded_value)

					if (!matched_variant) {
						//TODO handle no match
						this.input.value = this.original_value
					}

					const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
					productForms.forEach((productForm) => {
						//if a product upsell is selected, use items array style
						const input = productForm.querySelector('input[name="id"]') || productForm.querySelector('input[name="items[0][id]"]')
						input.value = matched_variant.id
						input.dispatchEvent(new Event("change", { bubbles: true }))
					})

					document.body.dispatchEvent(
						new CustomEvent("variantChange", {
							detail: {
								currentVariant: matched_variant,
							},
						})
					)
					//used if there is an error
					this.original_value = this.input.value
				}, choke)
			}

			matchingVariantValue(cent_value) {
				return this.variant_data[cent_value]
			}
		}
	)
}
